module.exports = __webpack_public_path__ + "static/media/microsoft.43c77bdb.svg";